import { ref, toRefs, inject, computed } from 'vue';
import tinycolor from 'tinycolor2';
import uniqueId from 'lodash/uniqueId';
import ChevronIcon from '../../../icons/arrows/component-lib.esm2.js';
import ProfileLinkWrapper from '../../component-lib.esm4.js';
import { getCSSVariableName, PROFILE_PREFIX } from '../../../styles/component-lib.esm3.js';
import ProfileBtn from '../../btn/component-lib.esm3.js';
import ProfileBtnSkeleton from '../../btn/component-lib.esm2.js';
import { useModel } from '../../../compositions/component-lib.esm13.js';
import { useBtnColors } from '../../compositions/component-lib.esm2.js';
import { useResizeObserver } from '../../../compositions/component-lib.esm7.js';

//
var script = {
  props: {
    options: {
      type: Object,
      required: true
    },
    isLoading: Boolean,
    value: Boolean
  },
  components: {
    ProfileBtn,
    ProfileLinkWrapper,
    ChevronIcon,
    ProfileBtnSkeleton
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const root = ref(null);
    const btn = ref(null);
    const content = ref(null);
    const btnHeight = ref(null);
    const lastLinkHeight = ref(0);
    const contentId = ref(uniqueId('stacked-layout-'));
    const {
      value
    } = toRefs(props);
    const {
      link,
      btnProps
    } = inject('link');
    const isOpen = useModel(value, val => emit('input', val));
    const {
      backgroundColor: btnBgColor,
      color: btnColor
    } = useBtnColors({
      noTransparency: true
    });
    const dimensions = ref(null);
    const btnVariant = computed(() => {
      const closedVariant = ['glossy', 'four-corners'].includes(btnProps.value.variant) ? btnProps.value.variant : null;
      return isOpen.value ? btnProps.value.variant : closedVariant;
    });
    const lastLinkRef = computed(() => {
      // Loop in loading and dimensions as a dependency
      // eslint-disable-next-line no-unused-vars
      props.isLoading;
      // eslint-disable-next-line no-unused-vars
      dimensions.value;
      return isOpen.value && content.value ? content.value.children[content.value.children.length - 1] : null;
    });
    useResizeObserver(lastLinkRef, _ref2 => {
      let [{
        contentRect
      }] = _ref2;
      lastLinkHeight.value = contentRect.height;
    });
    useResizeObserver(computed(() => {
      var _btn$value;
      return (_btn$value = btn.value) === null || _btn$value === void 0 ? void 0 : _btn$value.$el;
    }), () => {
      btnHeight.value = btn.value.$el.offsetHeight;
    });
    useResizeObserver(content, _ref3 => {
      let [entry] = _ref3;
      dimensions.value = entry.contentRect;
    });
    const classes = computed(() => {
      return {
        'v-stacked-layout--open': isOpen.value,
        'v-stacked-layout--closed': !isOpen.value
      };
    });
    const styles = computed(() => {
      return {
        '--c-connector-color': tinycolor(btnBgColor.value).setAlpha(0.25).toRgbString(),
        '--c-last-link-height': `${lastLinkHeight.value}px`
      };
    });
    const btnStyles = computed(() => {
      const extras = {};
      // Remove alpha from btn background
      if (!isOpen.value) {
        extras[getCSSVariableName(PROFILE_PREFIX, 'btnBgColor')] = btnBgColor.value;
        extras[getCSSVariableName(PROFILE_PREFIX, 'btnColor')] = btnColor.value;
      }
      return {
        '--c-box-shadow-color': `rgba(${tinycolor(btnBgColor.value).isDark() ? '255,255,255' : '0,0,0'}, .15)`,
        '--c-btn-height': btnHeight.value ? `${btnHeight.value}px` : '',
        ...extras
      };
    });
    const linesStyles = computed(() => {
      if (!dimensions.value) return {};
      return {
        height: `${dimensions.value.height}px`,
        width: `${dimensions.value.width}px`
      };
    });
    function handleClick() {
      if (!isOpen.value) emit('click');
      isOpen.value = !isOpen.value;
    }
    return {
      btnBgColor,
      root,
      btn,
      contentId,
      link,
      btnProps,
      btnVariant,
      handleClick,
      isOpen,
      classes,
      styles,
      btnStyles,
      content,
      linesStyles
    };
  }
};
export { script as default };